import api from './index'

export const loginAdmin = (credentials) => {
  return api.post('/api/auth/login', credentials)
}

export const getCurrentUser = () => {
  return api.get('/api/auth/me')
}
